<template>
  <!-- 红宝书融合课程-->
  <div class="shehuigongnengkaifake">
    <CertQuery :logo="Logo18" :type="'hbszl'" :color="'#294db0'" />
  </div>
</template>

<script>
import CertQuery from '../component/certQuery.vue'
import Logo18 from '@/assets/images/logo18.jpg'

export default {
  name: 'SheHuiGongNengKaiFa',
  components: {
    CertQuery
  },
  data() {
    return {
      Logo18
    }
  }
}
</script>